import { render } from "./NewSession.vue?vue&type=template&id=779af610&scoped=true&ts=true"
import script from "./NewSession.vue?vue&type=script&lang=ts"
export * from "./NewSession.vue?vue&type=script&lang=ts"

import "./NewSession.vue?vue&type=style&index=0&id=779af610&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/Development/Stefania/assessment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779af610"]])

export default __exports__